const routes = [
    {
        path: '/',
        redirect: '/admin'
    },
    {
        path: '/home',
        name: 'home',
        component: () => import('@/view/home/homePage.vue'),
        meta: {title: '搜索'},
    },
    {
        path: '/stationDetail',
        component: () => import('@/view/overview/powerStationDetail.vue'),
        meta: {title: '👍详情', requireAuth: true}
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/view/login/loginPage.vue'),
        meta: {title: '登陆'},
    },
    {
        path: '/deviceDetail',
        name: 'login',
        component: () => import('@/view/overview/toolDetailPage.vue'),
        meta: {title: '登陆'},
    },

    {
        path: '/admin',
        component: () => import('@/view/index/indexPage.vue'),
        redirect: '/admin/overview',
        children: [
            {
                path: '/admin/overview',
                component: () => import('@/view/overview/overviewPage.vue'),
                meta: {title: '总览', requireAuth: true}
            },
            {
                path: '/admin/deviceDetail',
                component: () => import('@/view/overview/toolDetailPage.vue'),
                meta: {title: '总览', requireAuth: true}
            },
            {
                path: '/admin/powerStation',
                component: () => import('@/view/overview/powerStationPage.vue'),
                meta: {title: '电站', requireAuth: true}
            },
            {
                path: '/admin/device',
                component: () => import('@/view/overview/toolPage.vue'),
                meta: {title: '设备', requireAuth: true}
            },
            {
                path: '/admin/warning',
                component: () => import('@/view/overview/dangerPage.vue'),
                meta: {title: '告警', requireAuth: true}
            },
            {
                path: '/admin/appManager',
                component: () => import('@/view/overview/appPage.vue'),
                meta: {title: '微逆', requireAuth: true}
            },
            {
                path: '/admin/appStationDetail',
                component: () => import('@/view/overview/appStationPage.vue'),
                meta: {title: '微逆', requireAuth: true}
            },
            {
                path: '/admin/appDeviceDetail',
                component: () => import('@/view/overview/appDevDetailPage.vue'),
                meta: {title: '微逆', requireAuth: true}
            },
        ],
    },

    {path: '/:pathMatch(.*)*', component: () => import('@/view/404Page/404Page.vue'),}


]

export default routes
